import urlJoin from "url-join";

import { rewriteUrls } from "@/app/_internal/rewriteUrls/rewriteUrls";
import { SHOP_PAGE_SLUG } from "@/app/[locale]/(default)/shop/constants";
import { formatPathname } from "@/utils/formatPathname";

type BuildProductJsonLdUrlParams = {
  siteUrl?: string;
  locale: string;
  categoryUrlKey: string;
  productUrlKey: string;
};

export const buildProductJsonLdUrl = ({
  siteUrl,
  locale,
  categoryUrlKey,
  productUrlKey,
}: BuildProductJsonLdUrlParams): string => {
  const productPath = formatPathname(SHOP_PAGE_SLUG, categoryUrlKey, productUrlKey);
  const localizedProductPath = urlJoin("/", locale, rewriteUrls(productPath, locale));

  return siteUrl ? urlJoin(siteUrl, localizedProductPath) : localizedProductPath;
};
